import React from "react"
//import I18n from "i18n-js/index.js.erb"

export default class EmailCampaignPresenterGeneral extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div>
        {this.renderNameAndCode()}
      </div>
    );
  };

  renderNameAndCode() {
    return(
      <div className="row" style={{ paddingLeft: 15 }} >
        <div className="col-md-2">
          <div className="form-group">
            <label>{`${I18n.t('code')}*`}</label>
            <p>{this.props.email_campaign.code}</p>
          </div>
        </div>
        <div className="col-md-3">
          <label>{`${I18n.t('name')}*`}</label>
          <div className="form-group">
            <p>{this.props.email_campaign.name} </p>
          </div>
        </div>
      </div>
    );
  };
};
